import { Component, OnInit, Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { ActivatedRoute,Router  } from '@angular/router';
import { Location } from '@angular/common';

import { CommonService } from '../service/common.service';

import { User } from '../service/users.model';
import { UsersService } from '../service/users.service';

import { Role } from '../app.constant';

@Component({
    selector: 'info-app',
      templateUrl: './info.component.html',
      styleUrls: ['info.component.css']
    })

export class infoComponent {

        constructor(
            private route: ActivatedRoute,
            private router: Router,
            private commonService: CommonService,
            private usersService: UsersService,
            private location: Location,
    ) { }

    infoTextJp: string ="";
    infoTextEn: string ="";
    ssoAuth: boolean = false;
    ssoKwansei: boolean = false;
    isLoaded : boolean = false;
    test:any = [];


    title="info";
    ngOnInit(): void {
        var page_url = location.href;
        this.ssoAuth = page_url.includes("wellnessSupportToolsSec");
        if(this.ssoAuth){
            this.ssoSignin();
        }else{
            this.isLoaded = true;
            this.commonService.loadingEnd();
        }
    };

    ssoSignin(): void {
        this.usersService.getServerConnection()
        .subscribe((res: Response) => {
            if(res["fuel_status"] == "NG"){
                // 処理なし
                this.isLoaded = true;
                this.commonService.loadingEnd();
            }else{
                if(res["fuel_results"] != null){
                    this.router.navigate(["/signin/"+res["fuel_results"]["code"]]);
                }else{
                    location.reload();
                }
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/c9903-info/info.component.ts